import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=06d5d720&"
import script from "./UploadDocument.vue?vue&type=script&lang=js&"
export * from "./UploadDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports